
	import { Component, Vue } from 'vue-property-decorator';
	import PatientRecall from '@/views/patient-table/PatientRecall.vue';
	import GetStartedView from '@/views/getting-started/GetStartedView.vue';
	import SplashScreen from '@/views/getting-started/SplashScreen.vue';

	@Component({
		components: { SplashScreen, GetStartedView, PatientRecall }
	})
	export default class App extends Vue {
		private classes: any;
		private currentComponent: string = 'GetStartedView';

		public next() {
			this.$router.push('threed');
		}

		public newViewHandler(view: string) {
			this.currentComponent = view;
		}
	}
